import WorkflowCanvasContextProvider from "../contexts/WorkflowCanvasContextProvider";
import WorkflowContextProvider from "../contexts/WorkflowContextProvider";

export const providers = [
    WorkflowCanvasContextProvider,
    WorkflowContextProvider,
]
